var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgContradictionIcon = function SvgContradictionIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_603_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.0998,
    y: 35.3234,
    width: 21,
    height: 5,
    transform: "rotate(180 59.0998 35.3234)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.6998,
    y: 42.5233,
    width: 4.43196,
    height: 17.38,
    rx: 2.21598,
    transform: "rotate(134.38 50.6998 42.5233)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.0998,
    y: 35.3234,
    width: 4.43196,
    height: 17.38,
    rx: 2.21598,
    transform: "rotate(-134.38 38.0998 35.3234)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 30,
    width: 21,
    height: 5,
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4,
    y: 22.8,
    width: 4.43196,
    height: 17.38,
    rx: 2.21598,
    transform: "rotate(-45.62 13.4 22.8)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30,
    width: 4.43196,
    height: 17.38,
    rx: 2.21598,
    transform: "rotate(45.62 26 30)",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5431 31.4487C35.9573 32.0345 35.9573 32.9843 36.5431 33.5701L46.0891 43.116C46.6748 43.7018 47.6246 43.7018 48.2104 43.116C48.7962 42.5302 48.7962 41.5805 48.2104 40.9947L39.7251 32.5094L48.2104 24.0241C48.7962 23.4383 48.7962 22.4886 48.2104 21.9028C47.6246 21.317 46.6748 21.317 46.0891 21.9028L36.5431 31.4487ZM59 31.0094L37.6038 31.0094V34.0094H59V31.0094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4569 33.5701C28.0427 32.9843 28.0427 32.0345 27.4569 31.4487L17.9109 21.9028C17.3252 21.317 16.3754 21.317 15.7896 21.9028C15.2038 22.4886 15.2038 23.4383 15.7896 24.0241L24.2749 32.5094L15.7896 40.9947C15.2038 41.5805 15.2038 42.5302 15.7896 43.116C16.3754 43.7018 17.3252 43.7018 17.9109 43.116L27.4569 33.5701ZM5 34.0094H26.3962V31.0094H5V34.0094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28.5,
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_603_11",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_603_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_603_11",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContradictionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contradiction-icon.f36e5ef9.svg";
export { ForwardRef as ReactComponent };